import React from 'react';
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';

/**
 * Prekrývané avatary s overflow badge +N — parita intr003 (`ServiceTaskList` AwaitingUserFormatter).
 * @see frontend/src/pages/service/ServiceTaskList.js (maxVisible = 3)
 */
export const OVERLAPPING_AVATAR_GROUP_MAX_VISIBLE = 3;

export function OverlappingAvatarGroup({
  items = [],
  getKey = (item, index) => item?.id ?? index,
  getDisplayName = (item) => item?.name ?? '',
  getColorKey = (item) => item?.username ?? item?.name ?? '',
  getUserInitials,
  getUserColor,
  className = 'flex items-center justify-start w-full h-full min-w-0',
}) {
  if (!items.length) return null;

  const maxVisible = OVERLAPPING_AVATAR_GROUP_MAX_VISIBLE;
  const visibleItems = items.slice(0, maxVisible);
  const extraItems = items.slice(maxVisible);
  const extraCount = extraItems.length;
  const extraNames = extraItems.map(getDisplayName).filter(Boolean);

  return (
    <div className={className}>
      <AvatarGroup>
        {visibleItems.map((item, index) => {
          const name = getDisplayName(item);
          const colorKey = getColorKey(item);
          return (
            <Avatar
              key={getKey(item, index)}
              title={name}
              label={getUserInitials?.(name)}
              shape="circle"
              style={{
                backgroundColor: getUserColor?.(colorKey) || '#6b7280',
                color: '#ffffff',
                marginRight: '5px',
              }}
            />
          );
        })}
        {extraCount > 0 ? (
          <Avatar
            label={`+${extraCount}`}
            shape="circle"
            title={extraNames.join('\n')}
            style={{ backgroundColor: '#6b7280', color: '#ffffff', marginRight: '5px' }}
          />
        ) : null}
      </AvatarGroup>
    </div>
  );
}
